/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderItemReference } from './orderItemReference';


export interface CustomerRmaItem { 
    id: string;
    status: CustomerRmaItem.StatusEnum;
    deviceId?: number;
    deviceTypeId?: string;
    deviceDescription: string;
    option: CustomerRmaItem.OptionEnum;
    performanceDescription?: string;
    orderItem?: OrderItemReference;
}
export namespace CustomerRmaItem {
    export const StatusEnum = {
        AwaitingArrival: 'AWAITING_ARRIVAL',
        Arrived: 'ARRIVED',
        Identified: 'IDENTIFIED',
        IntakeCompleted: 'INTAKE_COMPLETED',
        Inspected: 'INSPECTED',
        AwaitingAllocation: 'AWAITING_ALLOCATION',
        AwaitingConfiguration: 'AWAITING_CONFIGURATION',
        ConfigurationSubmitted: 'CONFIGURATION_SUBMITTED',
        InProduction: 'IN_PRODUCTION',
        Tested: 'TESTED',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        IntakeFailed: 'INTAKE_FAILED',
        Stored: 'STORED',
        Disposed: 'DISPOSED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const OptionEnum = {
        Refurbish: 'REFURBISH',
        Store: 'STORE',
        Dispose: 'DISPOSE'
    } as const;
    export type OptionEnum = typeof OptionEnum[keyof typeof OptionEnum];
}


export type StatusEnum = typeof CustomerRmaItem.StatusEnum[keyof typeof CustomerRmaItem.StatusEnum];
